/**
 * Created by mnaughton on 10/22/2015.
 * @module app/views/map/MapContext
 */

import MapContextBase from "app/views/map/MapContextBase";
import BoundOperationSet from "core/models/BoundOperationSet";
import LayoutOperations from "app/operations/map/LayoutOperations";
import MapServiceBaseOperations from "app/operations/map/MapServiceBaseOperations";
import LayerOperations from "app/operations/map/LayerOperations";
import GeometryArrayOperations from "app/operations/map/GeometryArrayOperations";
import SearchOperations from "app/operations/map/SearchOperations";
import SecurityOperations from "app/operations/map/SecurityOperations";
import FeatureContainerOperations from "app/operations/map/FeatureContainerOperations";
import _ from "underscore";
import ErrorUtils from "app/utils/ErrorUtils";
import messenger from "app/Messenger";
var MapContext = MapContextBase.extend({
  createOperations: function () {
    var parentOperations = MapContextBase.prototype.createOperations.apply(
      this,
      arguments
    );
    var self = this;
    var getConfiguration = _.bind(this.getConfiguration, this);
    var getSelection = _.bind(this.getSelection, this);
    var getSelectedService = _.bind(this.getSelectedService, this);
    var getSelectedLayer = _.bind(this.getSelectedLayer, this);

    var layoutOperations = LayoutOperations.bindAll(
      getConfiguration,
      _.bind(function (model, message) {
        if (model != this.getConfiguration()) {
          this.setConfiguration(model);
        }

        if (message) {
          messenger.success(message);
        }
      }, this),
      ErrorUtils.errorHandler(this)
    );

    var serviceOperations = MapServiceBaseOperations.bindAll(
      getSelectedService,
      _.bind(function (model, message) {
        if (message) {
          messenger.success(message);
        }
      }, this),
      ErrorUtils.errorHandler(this)
    );

    var layerOperations = LayerOperations.bindAll(
      getSelectedLayer,
      _.bind(function (model, message) {
        if (message) {
          messenger.success(message);
        }
      }, this),
      ErrorUtils.errorHandler(this)
    );

    var geometryOperations = GeometryArrayOperations.bindAll(
      getSelection,
      _.bind(function (model, message) {
        if (message) {
          messenger.success(message);
        }
      }, this),
      ErrorUtils.errorHandler(this)
    );

    var searchOperations = SearchOperations.bindAll(
      getSelection,
      _.bind(function (model, message) {
        if (message) {
          messenger.success(message);
        }
      }, this),
      ErrorUtils.errorHandler(this)
    );

    var securityOperations = SecurityOperations.bindAll(
      getSelection,
      _.bind(function (model, message) {
        if (message) {
          messenger.success(message);
        }
      }, this),
      ErrorUtils.errorHandler(this)
    );

    var featureContainerOperations = FeatureContainerOperations.bindAll(
      getSelection,
      _.bind(function (model, message) {
        if (message) {
          messenger.success(message);
        }
      }, this),
      ErrorUtils.errorHandler(this)
    );

    return new BoundOperationSet(
      _.flatten([
        layoutOperations.models,
        serviceOperations.models,
        layerOperations.models,
        geometryOperations.models,
        searchOperations.models,
        parentOperations.models,
        securityOperations.models,
        featureContainerOperations.models,
      ])
    );
  },
});

export default new MapContext("");



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/map/MapContext.js
// module id = 21
// module chunks = 1